import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "v-countdown" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "digit" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "digit" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "digit" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "min", -1)
const _hoisted_9 = { class: "digit" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Sec", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_ctx.days > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.days), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.days > 1 ? 'days' : 'day'), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.hours), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.hours > 1 ? 'hours' : 'hour'), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.minutes), 1),
        _hoisted_8
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.seconds), 1),
        _hoisted_10
      ])
    ])
  ]))
}